import { AnimatePresence, motion } from 'framer-motion';
import React, { FC } from 'react';

import Book from '@/components/Layout/Header/Search/Suggestions/Book';
import HorizontalScroll from '@/components/Layout/Header/Search/Suggestions/HorizontalScroll';

import { Book as IBook } from '@/utils/interfaces/Library/Books';

interface Props {
  books?: IBook[];
  onClickBook?: () => void;
}

const BookCarousel: FC<Props> = ({ books = [], onClickBook }) => {
  return (
    <HorizontalScroll scrollAmount={250} className='sm:gap-3 gap-2'>
      <AnimatePresence mode='popLayout'>
        {books?.map((book, index) => (
          <motion.div
            key={book._id}
            layout
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.25 }}
          >
            <Book onClickBook={onClickBook} book={book} key={index} />
          </motion.div>
        ))}
      </AnimatePresence>
    </HorizontalScroll>
  );
};

export default BookCarousel;
